import browserUpdate from 'browser-update'

document.addEventListener('DOMContentLoaded', function () {
    browserUpdate({
        // test: true,
        reminder: 0,
        noclose: true,
        l: "ru",
        text: { 'msg': 'К сожалению, Ваш браузер ({brow_name}) – устарел. <br />Установите, пожалуйста, другой бразуер для просмотра данного сайта.', msgmore: '', 'bupdate': 'Обновить браузер', 'bignore': '' },
        required: {
            e: 12
        },
        insecure: false,
        shift_page_down: false,
        onshow: () => {
            const div = document.createElement('div')
            div.classList.add('buorg-overlay')
            document.body.appendChild(div)
            document.body.style.overflow = 'hidden'
        }
    })
})